import { Chip, SxProps, Theme } from '@mui/material';
import { mixinSx } from '@watershed/style/styleUtils';

/**
 * A styled Chip component for displaying keyboard shortcuts with proper semantic markup.
 * Uses the <kbd> element for accessibility and applies consistent keyboard shortcut styling.
 */
export default function KbdChip({
  label,
  sx,
}: {
  label: string | number;
  sx?: SxProps<Theme>;
}) {
  return (
    <Chip
      label={label}
      size="small"
      component="kbd"
      sx={mixinSx(
        {
          backgroundColor: (theme) => theme.palette.grey05,
          color: (theme) => theme.palette.grey80,
          borderRadius: '4px',
          border: (theme) => `1px solid ${theme.palette.grey20}`,
          borderBottom: (theme) => `2px solid ${theme.palette.grey20}`,
          minWidth: 20,
          '& .MuiChip-label': {
            fontFamily: (theme) => theme.typography.fontFamilyMonospace,
            fontSize: 12,
            fontWeight: (theme) => theme.typography.fontWeightRegular,
            padding: 0.5,
            textTransform: 'uppercase',
          },
        },
        sx
      )}
    />
  );
}
